module.exports = __webpack_public_path__ + "static/img/img2x.1781caa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/family/img2x.png
// module id = OFB1
// module chunks = 1